import style from "./Update.module.scss";
import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import { nervePostSchema } from "../../components/validation/Schema";
import { SyncOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { notifyNervePost } from "../../redux/admin/actions/admin.actions";
import { loadHospitals } from "../../redux/admin/actions/admin.actions";

import { SelectField } from "../../components/Form/SelectField";
import { agentAddedSuccessToast } from "../../components/NotificationToast";
const CreateForm = ({ setCreateModal, handleSuccessPost }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [prem, setPrem] = useState([]);
  const [hospitalName, sethospitalName] = useState();
  const { hospitals } = useSelector((state) => state.adminReducer);
  const [refId, setrefId] = useState();

  useEffect(() => {
    dispatch(loadHospitals());
    const option = hospitals?.map((p) => ({
      label: p.name,
      value: p.ref_id,
    }));
    setPrem(option);
  }, [dispatch, hospitals]);
  // console.log("hospital", hospitals);
  return (
    <Formik
      initialValues={{
        ref_id: "",
        title: "",
        message: "",
      }}
      validationSchema={nervePostSchema}
      onSubmit={(values, actions) => {
        try {
          setLoading(true);
          dispatch(
            notifyNervePost({
              ref_id: values.ref_id.value,
              title: values.title,
              message: values.message,
            })
          );

          actions.resetForm({
            hospitalName: "",
            title: "",
            message: "",
          });
          handleSuccessPost();
          agentAddedSuccessToast();
         
          setCreateModal(false);
          setLoading(false);
        } catch (error) {
          console.log("eeor", error);
        }
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleSubmit,
        isSubmitting,
        handleBlur,
      }) => (
        <Form onSubmit={handleSubmit}>
          <h3 className="text-center" style={{color: "#B70303", fontWeight: "bold" }}>NOTIFY NERVE</h3>
          <div className="form-group">
            <label htmlFor="hospitalName">Hospital Name</label>
            {/* <Field
              type="text"
              className="form-control"
              id="hospitalName"
              name="hospitalName"
              // onChange={handleChange}
              onBlur={handleBlur}
              // value={values.hospitalName}
            /> */}
            <SelectField
              name="ref_id"
              placeholder={"select hospital"}
              // onChange={handleChange}
              // onChange={(selectedValue) => {
              //   console.log("Selected Hospital Name:", selectedValue);

              //   // Update the Formik field value
              //   handleChange("hospitalName")(selectedValue);

              //   // Update the selected hospital's ref_id
              //   setSelectedHospitalRefId(selectedValue);
              //   console.log("Selected Hospital Ref_ID:", selectedValue);
              // }}
              // className="form-control"
              // as="select"
              // className={`${Styles.formInput} shadow-none form-control`}
              // onBlur={() => {}}
              options={prem}
              // required
            />
            {/* {errors.hospitalName && touched.hospitalName ? (
              <div className="text-danger">{errors.hospitalName}</div>
            ) : null} */}
          </div>

          <div className="form-group">
            <label htmlFor="title">Title</label>
            <Field
              type="text"
              className="form-control"
              id="title"
              name="title"
              // onChange={handleChange}
              onBlur={handleBlur}
              // value={values.title}
            />
            {errors.title && touched.title ? (
              <div className="text-danger">{errors.title}</div>
            ) : null}
          </div>

          <div className="form-group">
            <label htmlFor="message">Message</label>
            <Field
              as="textarea"
              className="form-control"
              id="message"
              name="message"
              // onChange={handleChange}
              onBlur={handleBlur}
              // value={values.message}
            />
            {errors.message && touched.message ? (
              <div className="text-danger">{errors.message}</div>
            ) : null}
          </div>

          <div className={style.buttonContainer}>
            <button
              type="submit"
              className={` shadow-none  ${style.actionBtn} ${style.reject}`}
              disabled={loading}
            >
            
              Submit
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default CreateForm;
